import React, {useCallback, useEffect, useMemo} from "react";
import Styles from './styles.module.scss'
import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import Moment from "react-moment";
import Timer from "../../components/_UI/timer";
import {useDispatch, useSelector} from "react-redux";
import {
    getPreviewProject,
    getUserData,
    joinProject,
    setAllocationModalStatus
} from "../../store/cabinet/action";
import MediaSlider from "../../components/_UI/mediaSlider";
import CabinetProjectDetails from "../../components/cabinetProjectDetails";
import ProgressBar from "../../components/_UI/progressBar";
import {projectsStatusHandler} from "../../helpers/projectsStatusHandler";
import {toast} from "react-toastify";



const LaunchpadPreviewPage = () => {
    const { t } = useTranslation();
    const {id} = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const userData = useSelector(store => store.cabinet.userData);
    const projectData = useSelector(store => store.cabinet.previewProject);

    const errHandler = useCallback((err) => {
        toast.error(err.message);
    }, []);


    const isReadyToInvest = useMemo(() => {
        const alreadyInvest =
            Number(projectData?.allocation_total || 0) -
            Number(projectData?.allocation_invested || 0);

        return Boolean(
            projectData?.is_user_project &&
            projectData?.project?.status === 'investable' &&
            projectData?.user_investment_available &&
            projectData?.allowed_allocation &&
            alreadyInvest > 0
        );
    }, [projectData]);


    const projectMainBtnHandler = () => {
        if (projectData?.is_user_project && projectData?.project?.status === 'investable'){
            return (
                <div
                    className={`${Styles.projectInfoBoxJoinBtnDsb} ${isReadyToInvest ? Styles.projectInfoBoxJoinBtnActive : null}`}
                    onClick={()=>{
                        if (isReadyToInvest){
                            dispatch(setAllocationModalStatus(true));
                        }
                    }}
                >
                    {t('Инвестировать')}
                </div>
            )
        } else if (projectData?.is_user_project){
            return(
                <div className={`${Styles.projectConnectNote}`}>
                    {t('Вы присоединились к проекту')}!
                </div>
            )
        } else {
            return (
                <div
                    className={`${Styles.projectInfoBoxJoinBtnDsb} ${userData?.user?.status_id && projectData?.project?.status === 'participation_allowed' ? Styles.projectInfoBoxJoinBtnActive : null}`}
                    onClick={()=>{
                        if (userData?.user?.status_id && projectData?.project?.status === 'participation_allowed'){
                            dispatch(joinProject(id));
                        }
                    }}
                >
                    {!projectData?.project?.status ? t('Скоро') : projectData.project.status === 'upcoming' ? t('Скоро') : t('Присоединиться к проекту')}
                </div>
            )
        }
    }

    useEffect(() => {
        dispatch(getUserData());
        dispatch(getPreviewProject(id, errHandler))
    }, [dispatch, id, errHandler]);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-up');
        }
    },[authStatus, navigate])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Проекты')}/>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.dateRow}`}>
                    <div className={`${Styles.navWrap}`}>
                        <div className={`${Styles.navItem}`} onClick={()=>{navigate('/projects')}}>{t('Проекты')}</div>
                        <div className={`${Styles.navItem}`}> > </div>
                        <div className={`${Styles.navItem} ${Styles.colorYellow}`}> {projectData?.project?.description?.title}</div>
                    </div>
                    <div className={`${Styles.dateWrap}`}>
                        <div className={`${Styles.date}`}>
                            {projectData?.project?.isLive ? <span className={`${Styles.colorOrange}`}>{('Окончание продажи')}</span> : <span className={`${Styles.colorYellow}`}>{t('Начало продажи')}</span>} {projectData?.project?.sale_opens_at ? <Moment format="DD/MM/YYYY | HH:mm">{projectData?.project?.sale_opens_at}</Moment> : null}
                        </div>
                        <div className={`${Styles.liveStatus} ${projectData?.project?.isLive ? Styles.liveStatusA : null}`}>
                            {projectData?.project?.isLive ? t('Открыто для участия') : t('Скоро')}
                        </div>
                    </div>
                </div>
                <div className={`${Styles.titleRow}`}>
                    <div className={`${Styles.logoWrap}`}>
                        <img src={projectData?.project?.logo} alt={projectData?.project?.description?.title}/>
                    </div>
                    <div className={`${Styles.titleBox}`}>
                        <div className={`${Styles.projectTitle}`}>{projectData?.project?.description?.title}</div>
                        <div className={`${Styles.projectDescription}`}>{projectData?.project?.description?.short_description}</div>
                    </div>
                </div>
                <div className={`${Styles.projectWrap}`}>
                    <div className={`${Styles.projectWrapPos}`}>
                        <div className={`${Styles.tabletWrap}`}>
                            <div className={`${Styles.titleRow}`}>
                                <div className={`${Styles.logoWrap}`}>
                                    <img src={projectData?.project?.logo} alt={projectData?.project?.description?.title}/>
                                </div>
                                <div className={`${Styles.titleBox}`}>
                                    <div className={`${Styles.projectTitle}`}>{projectData?.project?.description?.title}</div>
                                    <div className={`${Styles.projectDescription}`}>{projectData?.project?.description?.short_description}</div>
                                </div>
                            </div>
                        </div>
                        {
                            projectData?.project?.media?.length > 0 ?
                                <MediaSlider media={projectData?.project?.media}/> :
                                <div className={`${Styles.projectImageWrap}`} style={{backgroundImage: `url(${projectData?.project?.image})`}}/>
                        }
                    </div>
                    <div className={`${Styles.projectInfoWrap}`}>
                        <div className={`${Styles.projectInfoBox}`}>
                            <div className={`${Styles.projectAbsIcon}`}>
                                <img src={projectData?.project?.blockchain?.logo} alt={projectData?.project?.blockchain?.name}/>
                            </div>
                            <div className={`${Styles.projectGoalWrap}`}>
                                <div className={`${Styles.projectGoalWrapName}`}>{t('Целевая сумма финансирования')}</div>
                                <div className={`${Styles.projectGoalWrapValue}`}>{projectData?.project?.fundraise_goal * 1} USDT</div>
                                {projectData?.project?.status === 'investable' || projectData?.project?.status === 'ended' ? <ProgressBar current={projectData?.project?.invested * 1} total={projectData?.project?.fundraise_goal * 1}/> : null}
                            </div>
                            {
                                projectData?.project?.status && projectData?.project?.status !== 'upcoming' ?
                                    <div className={`${Styles.projectInfoBoxRow}`}>
                                        <div className={`${Styles.projectInfoBoxRowName}`}>{t('Участники')}</div>
                                        <div className={`${Styles.projectInfoBoxRowValue}`}>{projectData?.participants ?? "0"}</div>
                                    </div> : null
                            }
                            <div className={`${Styles.projectInfoBoxRow}`}>
                                <div className={`${Styles.projectInfoBoxRowName}`}>{t('Цена токена')}</div>
                                <div className={`${Styles.projectInfoBoxRowValue}`}>{projectData?.project?.price_per_token * 1} USDT</div>
                            </div>
                            <div className={`${Styles.projectInfoBoxRow}`}>
                                <div className={`${Styles.projectInfoBoxRowName}`}>{t('Токен сбора средств')}</div>
                                <div className={`${Styles.projectInfoBoxRowValue}`}>{projectData?.project?.raise_token} on {projectData?.project?.blockchain?.name}</div>
                            </div>
                            <div className={`${Styles.projectInfoBoxDateRow}`}>
                                <div className={`${Styles.projectInfoBoxDateRowNameWrap}`}>
                                    <div className={`${Styles.projectInfoBoxDateRowName}`}>{t('Одобрен')}</div>
                                    <div className={`${Styles.projectInfoBoxDateRowStatus}`}>{t('Гарантировано')}</div>
                                </div>
                                <div className={`${Styles.projectInfoBoxDateRowValueWrap}`}>
                                    {projectData?.project?.allow_listed_guaranteed_at ? <Timer targetDate={projectData?.project?.allow_listed_guaranteed_at}/> : null}
                                    <div className={`${Styles.projectInfoBoxDateRowValue}`}>{projectData?.project?.allow_listed_guaranteed_at ? <Moment format="DD/MM/YYYY | HH:mm">{projectData?.project?.allow_listed_guaranteed_at}</Moment> : null}</div>
                                </div>
                            </div>
                            <div className={`${Styles.projectInfoBoxDateRow}`}>
                                <div className={`${Styles.projectInfoBoxDateRowNameWrap}`}>
                                    <div className={`${Styles.projectInfoBoxDateRowName}`}>{t('Одобрен')} (FCFS)</div>
                                    <div className={`${Styles.projectInfoBoxDateRowStatus}`}>FCFS</div>
                                </div>
                                <div className={`${Styles.projectInfoBoxDateRowValueWrap}`}>
                                    {projectData?.project?.allow_listed_fcfs_at ? <Timer targetDate={projectData?.project?.allow_listed_fcfs_at}/> : null}
                                    <div className={`${Styles.projectInfoBoxDateRowValue}`}>{projectData?.project?.allow_listed_fcfs_at ? <Moment format="DD/MM/YYYY | HH:mm">{projectData?.project?.allow_listed_fcfs_at}</Moment> : null}</div>
                                </div>
                            </div>
                            {projectMainBtnHandler()}
                        </div>
                        <div className={`${Styles.projectSellBtn}`}>{projectsStatusHandler(projectData?.project?.status)}</div>
                    </div>
                </div>
                <CabinetProjectDetails currentProject={projectData?.project}/>
            </div>
        </section>
    );
};

export default LaunchpadPreviewPage;